import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useState } from "react";
import ArrowUpDown from "../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/arrow-up-down.js";
import TrendingUp from "../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/trending-up.js";
import ArrowUp from "../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/arrow-up.js";
import CheckCircle from "../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/check-circle.js";
import XCircle from "../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/x-circle.js";
const DOMAIN_LABELS = {
  abstraction: "무시",
  change: "변화",
  relation: "관계"
};
function QuestionBreakdownTable({ questions, hasPostAiq = true }) {
  const [sortField, setSortField] = useState("difficulty");
  const [sortDir, setSortDir] = useState("asc");
  const hasAdvanced = questions.some((q) => q.preScoreAdvanced != null);
  const toggleSort = (field) => {
    if (sortField === field) {
      setSortDir((d) => d === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDir("asc");
    }
  };
  const sorted = [...questions].sort((a, b) => {
    const dir = sortDir === "asc" ? 1 : -1;
    switch (sortField) {
      case "difficulty":
        return (a.difficultyLevel - b.difficultyLevel) * dir;
      case "domain":
        return ((a.domains[0] || "") > (b.domains[0] || "") ? 1 : -1) * dir;
      case "improved":
        return ((a.improved ? 1 : 0) - (b.improved ? 1 : 0)) * -dir;
      default:
        return 0;
    }
  });
  const formatTime = (sec) => {
    if (sec == null) return "-";
    if (sec < 60) return `${sec}초`;
    return `${Math.floor(sec / 60)}분 ${sec % 60}초`;
  };
  const formatScore = (score) => {
    if (score == null) return "-";
    return Math.round(score).toString();
  };
  const ResultIcon = ({ correct }) => correct ? /* @__PURE__ */ jsx(CheckCircle, { className: "w-5 h-5 text-green-500" }) : /* @__PURE__ */ jsx(XCircle, { className: "w-5 h-5 text-red-400" });
  return /* @__PURE__ */ jsxs("div", { className: "bg-white rounded-xl shadow-2xs border border-gray-100 overflow-hidden", children: [
    /* @__PURE__ */ jsx("div", { className: "p-6 pb-4", children: /* @__PURE__ */ jsx("h3", { className: "text-lg font-semibold text-gray-900", children: "문제별 상세 비교" }) }),
    /* @__PURE__ */ jsx("div", { className: "overflow-x-auto", children: /* @__PURE__ */ jsxs("table", { className: "w-full text-sm", children: [
      /* @__PURE__ */ jsx("thead", { className: "bg-gray-50 border-y border-gray-200", children: /* @__PURE__ */ jsxs("tr", { children: [
        /* @__PURE__ */ jsx("th", { className: "px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase", children: "#" }),
        /* @__PURE__ */ jsx("th", { className: "px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase cursor-pointer", onClick: () => toggleSort("domain"), children: /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-1", children: [
          "분야 ",
          /* @__PURE__ */ jsx(ArrowUpDown, { className: "w-3 h-3" })
        ] }) }),
        /* @__PURE__ */ jsx("th", { className: "px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase cursor-pointer", onClick: () => toggleSort("difficulty"), children: /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-1", children: [
          "난이도 ",
          /* @__PURE__ */ jsx(ArrowUpDown, { className: "w-3 h-3" })
        ] }) }),
        /* @__PURE__ */ jsx("th", { className: "px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase", children: "Pre 결과" }),
        hasPostAiq && /* @__PURE__ */ jsx("th", { className: "px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase", children: "Post 결과" }),
        /* @__PURE__ */ jsx("th", { className: "px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase", children: "Pre 시간" }),
        hasPostAiq && /* @__PURE__ */ jsx("th", { className: "px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase", children: "Post 시간" }),
        hasAdvanced && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("th", { className: "px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase", children: "Pre 점수" }),
          hasPostAiq && /* @__PURE__ */ jsx("th", { className: "px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase", children: "Post 점수" })
        ] }),
        hasPostAiq && /* @__PURE__ */ jsx("th", { className: "px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase cursor-pointer", onClick: () => toggleSort("improved"), children: /* @__PURE__ */ jsxs("span", { className: "flex items-center justify-center gap-1", children: [
          "향상 ",
          /* @__PURE__ */ jsx(ArrowUpDown, { className: "w-3 h-3" })
        ] }) })
      ] }) }),
      /* @__PURE__ */ jsx("tbody", { className: "divide-y divide-gray-100", children: sorted.map((q, i) => /* @__PURE__ */ jsxs("tr", { className: `hover:bg-gray-50 ${q.improved ? "bg-green-50/30" : ""}`, children: [
        /* @__PURE__ */ jsx("td", { className: "px-4 py-3 text-gray-500", children: i + 1 }),
        /* @__PURE__ */ jsx("td", { className: "px-4 py-3", children: /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1", children: q.domains.length > 0 ? q.domains.map((d) => /* @__PURE__ */ jsx("span", { className: "px-2 py-0.5 text-xs rounded-full bg-gray-100 text-gray-700", children: DOMAIN_LABELS[d] || d }, d)) : /* @__PURE__ */ jsx("span", { className: "text-gray-400", children: "-" }) }) }),
        /* @__PURE__ */ jsx("td", { className: "px-4 py-3", children: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1", children: [
          Array.from({ length: 5 }, (_, j) => /* @__PURE__ */ jsx("div", { className: `w-2 h-2 rounded-full ${j < q.difficultyLevel ? "bg-amber-400" : "bg-gray-200"}` }, j)),
          /* @__PURE__ */ jsxs("span", { className: "ml-1 text-xs text-gray-500", children: [
            "Lv.",
            q.difficultyLevel
          ] })
        ] }) }),
        /* @__PURE__ */ jsx("td", { className: "px-4 py-3 text-center", children: /* @__PURE__ */ jsx(ResultIcon, { correct: q.preCorrect }) }),
        hasPostAiq && /* @__PURE__ */ jsx("td", { className: "px-4 py-3 text-center", children: /* @__PURE__ */ jsx(ResultIcon, { correct: q.postCorrect }) }),
        /* @__PURE__ */ jsx("td", { className: "px-4 py-3 text-right text-gray-600", children: formatTime(q.preElapsedSec) }),
        hasPostAiq && /* @__PURE__ */ jsx("td", { className: "px-4 py-3 text-right text-gray-600", children: formatTime(q.postElapsedSec) }),
        hasAdvanced && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("td", { className: "px-4 py-3 text-right text-gray-600 font-mono text-xs", children: formatScore(q.preScoreAdvanced) }),
          hasPostAiq && /* @__PURE__ */ jsx("td", { className: "px-4 py-3 text-right text-gray-600 font-mono text-xs", children: formatScore(q.postScoreAdvanced) })
        ] }),
        hasPostAiq && /* @__PURE__ */ jsx("td", { className: "px-4 py-3 text-center", children: /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-center gap-0.5", children: [
          q.improved && /* @__PURE__ */ jsx(TrendingUp, { className: "w-5 h-5 text-green-500" }),
          !q.improved && q.advancedImproved && /* @__PURE__ */ jsx(ArrowUp, { className: "w-4 h-4 text-blue-400" })
        ] }) })
      ] }, q.quizId)) })
    ] }) })
  ] });
}
export {
  QuestionBreakdownTable
};
//# sourceMappingURL=QuestionBreakdownTable.js.map
